// sagas.js
import { takeLatest, put, call } from "redux-saga/effects";
import * as types from "../../actionTypes";
import AxiosInstance from "../../../services/AxiosInstance";
import { fetchCountriesSuccess,fetchCountriesFailure } from "./actions";

function* fetchCountry(action) {
  try {
    
    // Call your API function here with action.payload.keyword
    const response = yield call(() =>
      AxiosInstance().post("/fetch_countries", action.payload)
    );
    if(response.data.status){

      yield put(fetchCountriesSuccess(response.data));
    }else{
      yield put(fetchCountriesFailure(response.data));
    }
  } catch (error) {
    // Dispatch failure action with the error
    yield put(fetchCountriesFailure({status:false,message:error.message}));
  }
}

// Watch for the latest FETCH_LOCATIONS_REQUEST action and call the saga
function* fetchCountriesSaga() {
  yield takeLatest(types.FETCH_COUNTRIES_REQUEST, fetchCountry);
}

export default fetchCountriesSaga;
